import { React } from "react";

import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";

import FormLogin from "../../components/FormLogin";
import LogoT2m from "../../assets/img/logo_t2m.png";
import LogoT2mWhite from "../../assets/img/logo_t2m_white.png";

import "./style.css";
import {
  MdContrast,
  MdOutlineTextDecrease,
  MdOutlineTextIncrease,
} from "react-icons/md";

function Login({
  setLogged,
  HandledarkMode,
  isDarkMode,
  decreaseFontSize,
  increaseFontSize,
}) {
  const AcessibilityItem = ({index, action, icon}) => {
    return (
      <Col>
        <div
          tabIndex={index}
          onKeyDown={(event) => {
            if (event.key === "Enter") {
              action();
            }
          }}
        >
          {icon}
        </div>
      </Col>
    );
  };

  return (
    <Container fluid>
      <Row>
        <Col className="coluna-esquerda" md={7}></Col>
        <Col className="coluna-direita" md={5}>
          <Row className="container-acessibility align-self-end mb-3">
            <AcessibilityItem
              index={0}
              action={HandledarkMode}
              icon={
                <MdContrast
                  onClick={HandledarkMode}
                  className="item-acessibility"
                  title="Alto Contraste"
                  size={28}
                />
              }
            />
            <AcessibilityItem
              index={0}
              action={increaseFontSize}
              icon={
                <MdOutlineTextIncrease
                  onClick={increaseFontSize}
                  className="item-acessibility"
                  title="Aumentar Fonte"
                  size={28}
                />
              }
            />
            <AcessibilityItem
              index={0}
              action={decreaseFontSize}
              icon={
                <MdOutlineTextDecrease
                  onClick={decreaseFontSize}
                  className="item-acessibility"
                  title="Diminuir Fonte"
                  size={24}
                />
              }
            />
          </Row>
          <Row>
            <Col className="titulo-area">
            {isDarkMode ? (
                  <img src={LogoT2mWhite} className="logo" alt="T2M" />
                ) : (
                  <img src={LogoT2m} className="logo" alt="T2M" />
                )}
              <span id="sigla">Life Design</span>
              <span>Sistema de padronização de layouts</span>
            </Col>
          </Row>
          <Row className="mt-2">
            <Col>
              <FormLogin setLogged={setLogged} />
            </Col>
          </Row>
        </Col>
      </Row>
    </Container>
  );
}

export default Login;
